// Totais por coluna do campo `table`.
//
// Uma coluna marcada com `sum: true` no layout ganha o somatório das linhas de
// `body` numa linha "Total" ao pé da tabela. O total NÃO é persistido: é sempre
// derivado do corpo, senão editar/apagar uma linha deixaria um número velho
// salvo no data form.
//
// A mesma regra está no backend (`PdfService::tableTotals`), que imprime os
// mesmos totais no PDF — mudou aqui, mude lá.

import { formatQuantity } from "./format";

// O valor da célula é texto livre digitado por quem preenche: pode vir com
// unidade ("10 kg"), no padrão pt/es ("1.234,56") ou no inglês ("1234.56").
// Aceitamos os dois separadores; o que não tiver número vira null (ignorado na
// soma, em vez de zerá-la).
function parseUserNumber(value) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "number") return Number.isNaN(value) ? null : value;

  // Fora dígitos, separadores e sinal, o resto é unidade/texto.
  let text = String(value).replace(/[^\d.,-]/g, "");
  if (text === "") return null;

  const hasComma = text.indexOf(",") !== -1;
  const hasDot = text.indexOf(".") !== -1;

  if (hasComma && hasDot) {
    // O separador decimal é o último a aparecer; o outro é de milhar.
    const decimal = text.lastIndexOf(",") > text.lastIndexOf(".") ? "," : ".";
    const thousand = decimal === "," ? "." : ",";
    text = text.split(thousand).join("").replace(decimal, ".");
  } else if (hasComma) {
    // "1,234" tanto pode ser milhar quanto decimal: só tratamos como milhar
    // quando os grupos são de 3 dígitos ("1,234,567").
    text = /^-?\d{1,3}(,\d{3})+$/.test(text)
      ? text.split(",").join("")
      : text.replace(",", ".");
  } else if (hasDot && /^-?\d{1,3}(\.\d{3})+$/.test(text)) {
    text = text.split(".").join("");
  }

  // Number (e não parseFloat) para casar com o `is_numeric` do backend: texto
  // malformado ("1.2.3") vira null nos dois lados, em vez de meio número aqui.
  const parsed = Number(text);
  return Number.isNaN(parsed) ? null : parsed;
}

// A tabela tem alguma coluna somada?
function hasTotals(columns) {
  return (columns || []).some((column) => column && column.sum === true);
}

// Total formatado por coluna (null onde a coluna não soma), alinhado por índice
// com `columns` — o mesmo índice que alinha as células de `body`.
function columnTotals(columns, body) {
  const rows = Array.isArray(body) ? body : [];

  return (columns || []).map((column, index) => {
    if (!column || column.sum !== true) return null;

    const total = rows.reduce((acc, row) => {
      const parsed = parseUserNumber(row ? row[index] : null);
      return parsed === null ? acc : acc + parsed;
    }, 0);

    return formatQuantity(total);
  });
}

export { parseUserNumber, hasTotals, columnTotals };
